import { ChangeDetectionStrategy, Component, Output, Input, EventEmitter } from '@angular/core';

import { Tariff } from '@personal-area/global/accounts/models';

@Component({
    selector: 'pac-account-card',
    templateUrl: './account-card.component.html',
    styleUrls: ['./account-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class AccountCardComponent {
  @Input() tariff: Tariff;
  @Output() selectTariff = new EventEmitter<void>();
}
